import * as React from "react";
import type { SVGProps } from "react";
const SvgTwitterXNegative = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    role="img"
    focusable={false}
    {...props}
  >
    <path
      fill="#1D1D1D"
      d="M11.429 8.852 17.014 2.5H15.69l-4.852 5.514L6.967 2.5H2.5l5.857 8.34L2.5 17.5h1.323l5.12-5.825 4.09 5.825H17.5M4.3 3.476h2.033l9.357 13.096h-2.033"
    />
  </svg>
);
export default SvgTwitterXNegative;
